import React, { useEffect, useState } from 'react'
import { HeaderSizes } from '../../constants'
import Icon from '../Icon'
import Header from '../Header'

const NoImageState = React.memo(({ width, centered, title, message }) => {
    const [size, setSize] = useState(null)

    useEffect(() => {
        let processedWidth = 30
        if (width) {
            processedWidth = width
        }
        setSize(processedWidth)
    }, [width])

    return (
        <div
            className={`rds-state ${
                centered ? 'rds-centered rds-text-align_center' : ''
            }`}
        >
            <Icon className='rds-m_bottom__sm' icon='FailPicture' size={size} />
            {title ? (
                <Header title={title} text={message} size={HeaderSizes.SMALL} />
            ) : null}
        </div>
    )
})

export default NoImageState
